import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
@Injectable()
export class HaHeaderViewServiceService {

  constructor(private http: HttpClient) { }
  public viewId: boolean = false;

  updateView(newValue): void {
    this.viewId = newValue;
  }

  getViewId(): boolean {
    return this.viewId;
  }

  updateHaListView(value) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Home/updateHaListView?value='+value);
  }

}
